/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from '../actions/auth'
// import { USER_REQUEST } from '../actions/user'
// import router from '../../routes/routes'
// import apiCall from '../../utils/api'
import axios from 'axios'

const state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false }

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
}

const API = process.env.ROOT_API
const ENDPOINT = 'auth'
const URL = API + ENDPOINT

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      // apiCall({url: 'auth', data: user, method: 'POST'})
      axios({ url: URL, data: user, method: 'POST' })
      .then(resp => {
        console.log(resp.data['access_token'])
        localStorage.setItem('user-token', resp.data['access_token'])
        axios.defaults.headers.common['Authorization'] = resp.data['access_token']
        commit(AUTH_SUCCESS, resp)
        // dispatch(USER_REQUEST)
        console.log(resp.token)
        resolve(resp)
      })
      .catch(err => {
        console.log('nao logou')
        commit(AUTH_ERROR, err)
        localStorage.removeItem('user-token')
        reject(err)
      })
      //(01-09-21) adicionado para caso de falhar a verificação acima, informa a msg ao usuário de erro ao logar.
      var log = localStorage.getItem('user-token')
      setTimeout(function(){
        if(log == null){
          console.log('nao logou')
          reject(401)
        }
      }, 5000);

    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('hash')
      localStorage.removeItem('user-token')
      delete axios.defaults.headers.common['Authorization']
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.token
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js